




import {Component, Prop, Vue} from "vue-property-decorator";
import {DistrictStore} from "@/modules/regionsv2/district/store";

@Component({
    name: "DistrictLabelV2"
})
export default class extends Vue {
    @Prop({ required: true, type: Number })
    readonly id!: number;

    get label() {
        return DistrictStore.data[this.id]?.name;
    }
}
